<template>
  <div class="poll-container">
    <div class="poll-loaded" v-if="loaded">
      <div class="poll-loading" v-show="loading">
        <div class="poll-loader">
          <div></div>
        </div>
      </div>
      <div class="card">
        <header class="card-header">
          <p class="card-header-title" v-if="poll.name">{{ poll.name }}</p>
          <p class="card-header-title" v-else>Name of Your Poll</p>
        </header>
        <div class="card-content">
          <div class="poll-questions">
            <div class="poll-questions-inner" :style="questionsInnerStyles">
              <div class="poll-question" :style="{ width: (100/poll.questions.length) + '%' }"
               v-for="(question, index) in poll.questions" v-bind:key="index">
                <h2 v-if="question.question">{{ question.question }}</h2>
                <h2 v-else>Question {{ index+1 }}</h2>
                <div v-for="(answer, answer_index) in question.answers" v-bind:key="answer_index">
                  <div :class="[question.answered == answer.id ?
                  'answer-container question-answer' : 'answer-container']">
                    <div class="field">
                      <div v-if="answer">
                        <b-radio @click.native="vote(answer, question)" :disabled="
                        (typeof(question.answered) != 'undefined'
                        && question.answered != ''
                        || (isPreview)) ? true : false"
                        :checked="question.answered == answer.id"
                        :native-value="answer.id" v-model="answer.radio">
                          <span>{{ answer.answer }}</span>
                        </b-radio>
                        <span class="percentage" v-if="question.answered">
                          ({{ answer.vote_percentage }} %)
                        </span>
                      </div>
                      <div v-else>
                        <b-radio disabled>
                          Answer {{ answer_index+1 }}
                        </b-radio>
                      </div>
                      <div class="answer_result" v-if="question.answered">
                        <progress class="progress is-primary" :value="answer.vote_percentage"
                        max="100"></progress>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <footer class="card-footer level">
          <div class="column is-narrow">
            <div class="poll_num">
              <p>Question {{ current_index }} of {{ poll.questions.length }}</p>
            </div>
          </div>
          <div class="column is-narrow">
            <div class="poll_buttons">
              <div class="buttons has-addons is-right">
                <div class="button" id="previous" @click="prev"
                :disabled="this.current_index != 1 ? false : true">Previous</div>
                <div class="button" id="next" @click="next"
                :disabled="((this.current_index < this.poll.questions.length
                && this.poll.questions[this.current_index-1].answered)
                || (isPreview && this.current_index < this.poll.questions.length))
                ? false : true">Next
              </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
    <div class="poll-loading" v-else>
      <div class="poll-loader">
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['slug', 'data', 'prefix'],
  data() {
    return {
      scrolled: 0,
      current_index: 1,
      questionsInnerStyles: {
        marginLeft: '0%',
        width: '100%',
      },
      poll: {},
      inner_offset: 0,
      loaded: true,
      loading: false,
      isPreview: false,
      routePrefix: '',
    };
  },
  methods: {
    next() {
      if (
        (this.current_index < this.poll.questions.length &&
          this.poll.questions[this.current_index - 1].answered) ||
        (this.isPreview && this.current_index < this.poll.questions.length)
      ) {
        this.inner_offset -= 100;
        this.current_index += 1;
      }
    },
    prev() {
      if (this.current_index !== 1) {
        this.inner_offset += 100;
        this.current_index -= 1;
      }
    },
    computeQuestionsInner() {
      this.questionsInnerStyles.marginLeft = `${this.inner_offset}%`;
      this.questionsInnerStyles.width = `${100 * this.poll.questions.length}%`;
    },
    vote(answer, question) {
      if (typeof answer.id !== 'undefined' && !this.isPreview && question.answered === false) {
        // before API call
        this.loading = true;

        // API call
        // -- success
        const canswer = answer;
        canswer.votes += 1;
        this.questionAnswered(question, canswer);
        this.loading = false;

        // -- fail
        // do something
      }
    },
    questionAnswered(question, answer) {
      const cquestion = question;
      cquestion.total_votes = 0;
      for (let i = 0; i < cquestion.answers.length; i += 1) {
        cquestion.total_votes += cquestion.answers[i].votes;
      }

      for (let i = 0; i < cquestion.answers.length; i += 1) {
        cquestion.answers[i].vote_percentage =
        parseInt(100 * (cquestion.answers[i].votes / cquestion.total_votes), 10);
      }
      cquestion.answered = answer.id;
    },
    createEmptyPoll() {
      this.poll = {
        name: 'Name of your Poll',
        questions: {
          id: '',
          question: '',
          answers: [
            { id: '', answer: '' },
            { id: '', answer: '' },
            { id: '', answer: '' },
          ],
          answered: true,
        },
      };
    },
  },
  watch: {
    inner_offset() {
      this.computeQuestionsInner();
    },
    poll_questions() {
      this.computeQuestionsInner();
    },
  },
  updated() {
    if (!this.slug) {
      this.poll = this.data;
    }
  },
  computed: {
    poll_questions() {
      return this.poll.questions;
    },
  },
  created() {
    // axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

    // if (process.env.MIX_ROUTE_PREFIX) {
    //   this.routePrefix = '/' + process.env.MIX_ROUTE_PREFIX
    // } else {
    //   if (this.prefix) {
    //     this.routePrefix = '/' + this.prefix
    //   }
    // }
    if (this.slug) {
      this.loaded = true;
      this.poll = {
        questions: [
          {
            id: '1',
            question: 'Best poll ever?',
            answers: [
              { id: 1, answer: 'this', votes: 219 },
              { id: 2, answer: 'that', votes: 29 },
              { id: 3, answer: 'mine', votes: 19 },
              { id: 4, answer: 'yours', votes: 21 },
            ],
            radio: 0,
            answered: false,
          },
          {
            id: '2',
            question: 'Best guy ever?',
            answers: [
              { id: 1, answer: 'John', votes: 21 },
              { id: 2, answer: 'Doe', votes: 2 },
              { id: 3, answer: 'Silver', votes: 19 },
            ],
            radio: 0,
            answered: false,
          },
        ],
      };
      //   var that = this
      //   axios.get(this.routePrefix + '/polls/api/' + this.slug + '.json')
      //       .then(function (response) {
      //         that.loaded = true
      //         that.poll = response.data
      //         for(var i = 0; i < that.poll.questions.length; i++){
      //           var answered =
      //           parseInt(localStorage.getItem("poll_question_" + that.poll.questions[i].id))
      //           if(answered){
      //             for(var j = 0; j < that.poll.questions[i].answers.length; j++){
      //               if(that.poll.questions[i].answers[j].id == answered){
      //                 that.questionAnswered(
      //                   that.poll.questions[i],
      //                   that.poll.questions[i].answers[j]
      //                  )
      //                 break
      //               }
      //             }
      //           }
      //         }
      //       })
      //       .catch(function (error) {
      //         console.log(error.message)
      //       })
    } else {
      this.poll = this.data;
      this.loaded = true;
      this.isPreview = true;
      this.computeQuestionsInner();
      this.createEmptyPoll();
    }
  },
};
</script>


<style lang="scss" scoped>
.poll-questions {
  width: 100%;
  overflow: hidden;
}
.poll-questions-inner {
  transform: translateZ(0);
  transition: all 800ms cubic-bezier(0.77, 0, 0.175, 1);
  transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);
}

.poll-question {
  float: left;
}

.panel-title {
  border-bottom: 1px solid #f1f1f1;
  padding-left: 20px;
}

.answer_result {
  padding-top: 5px;
}

.answer_result .poll-percentage-bar span {
  content: "";
  width: 0%;
  height: 100%;
  background: #3498db;
  position: absolute;
}

.answer_result .poll-percentage-bar .percentage-mask {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #fff;
  right: 0px;
  top: 0px;
  animation-duration: 1.5s;
  animation-fill-mode: both;
  animation-timing-function: ease-in;
  animation-name: poll-mask-uncover;
  z-index: 9;
}

.card, .card-header, .card-footer{
  box-shadow: none;
  border: 0;
  margin: 0;
}

.card-header-title {
  font-size: 1rem;
}

.card-content {
  border-top: 1px solid #f1f1f1;
  border-bottom: 1px solid #f1f1f1;
}

@keyframes poll-mask-uncover {
  from {
    transform-origin: right center;
    width: 100%;
  }

  to {
    transform-origin: right center;
    width: 0%;
  }
}

.poll_num p {
  font-size: 12px;
  text-transform: uppercase;
  color: #bbb;
}

.poll-container {
  border: 1px solid #f1f1f1;
}

.poll-loading {
  background: #f1f1f1;
  display: block;
  min-height: 200px;
  width: 100%;
  margin-top: 80px;
  border-radius: 4px;
  position: relative;
}

.poll-loaded {
  position: relative;
}

.poll-loaded .poll-loading {
  position: absolute;
  z-index: 9;
  margin-top: 0px;
  background: rgba(255, 255, 255, 0.7);
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
}

/********** LOADER CSS **********/

.poll-loader,
.poll-loader > div {
  position: relative;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.poll-loader {
  display: block;
  font-size: 0;
  color: #ccc;
  width: 32px;
  height: 32px;
  left: 50%;
  margin-left: -16px;
  top: 50%;
  margin-top: -16px;
  position: absolute;
}

.poll-loader > div {
  display: inline-block;
  float: none;
  background-color: currentColor;
  border: 0 solid currentColor;
  width: 32px;
  height: 32px;
  background: transparent;
  border-width: 2px;
  border-bottom-color: transparent;
  border-radius: 100%;
  animation: poll-rotate 0.75s linear infinite;
}

/*
  * Animation
  */
@keyframes poll-rotate {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
